import React from 'react';
import type { FC } from 'react';
import classNames from 'classnames';

import styles from './priceDetails.module.css';

interface PriceDetailsProps {
  className?: string;
  children?: React.ReactNode;
}

const PriceDetails: FC<PriceDetailsProps> = ({ children, className = '' }) =>
  children ? (
    <ul className={classNames(className, styles.list)}>{children}</ul>
  ) : null;

export default PriceDetails;
